import api from "./axios.service";
import { getQueryStringFromObject } from "./common.service";
const axios = api;

async function connectToSpotify() {
    try {
        let response = await axios.get('/spotify/authorize');
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function spotifyConnectionStatus() {
    try {
        let response = await axios.get('/spotify/connectionStatus');
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function callbackSpotify(code) {
    try {
        let response = await axios.get(`/spotify/callback?code=${code}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function playMusicSpotify(query={}) {
    try {
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = `?${queryString}`;
        }
        let response = await axios.get(`/spotify/playMusic${queryString}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function pauseMusicSpotify(query={}) {
    // This function is not used in the app, but it is here for future use if needed
    try {
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = `?${queryString}`;
        }
        let response = await axios.get(`/spotify/pauseMusic${queryString}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function getTrackDetails(song_id) {
    try {
        let response = await axios.get(`/spotify/track/details?song_id=${song_id}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

async function searchTracksSpotify(query={}) {
    try {
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = `?${queryString}`;
        }
        let response = await axios.get(`/spotify/searchTracks${queryString}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

export {
    connectToSpotify,
    spotifyConnectionStatus,
    callbackSpotify,
    playMusicSpotify,
    pauseMusicSpotify,
    getTrackDetails,
    searchTracksSpotify
}
